import { Component, OnInit } from '@angular/core';
import { ISubscription } from 'app/store/models/subscription.model';
import { Button, ButtonColor, ButtonSize } from 'app/store/models/button.model';
import { ActivatedRoute } from '@angular/router';
import { SubscriptionService } from 'app/store/services/subscription.service';

@Component({
  selector: 'app-show-subscription',
  templateUrl: './show-subscription.component.html',
  styleUrls: ['./show-subscription.component.scss'],
})
export class ShowSubscriptionComponent implements OnInit {
  subscription: ISubscription;

  backBButtonProperties: Button = {
    color: ButtonColor.WHITE,
    route: ['/subscriptions'],
    size: ButtonSize.SMALL,
    text: 'Back',
  };

  constructor(
    private activatedRoute: ActivatedRoute,
    private subscriptionService: SubscriptionService
  ) {}

  ngOnInit() {
    const subscriptionId = this.activatedRoute.snapshot.params.id;

    if (subscriptionId) {
      this.subscriptionService
        .viewSubscription(subscriptionId)
        .subscribe(
          (subscription: ISubscription) => (this.subscription = subscription)
        );
    }
  }
}
